<script>
import VehicleInfoWindowMask from '@/components/VehicleInfoWindowMask'
import CalendarInput from '@/components/CalendarInput'
import {DateUtil, formatDate} from '@/utils/date.js'
import {StringUtil} from '@/utils/StringUtil'
import dialog from '@/components/Dialog'
let date = new Date()
var loginDate = formatDate(date, 'yyyyMMdd')
export default {
  components: {
    VehicleInfoWindowMask, CalendarInput, 'v-dialog': dialog
  },
  created () {
    // 判断当前功能是否为登录，非登录功能从Session中读取车辆详细
    if (this.func !== 'login') {
      this.vehicle = JSON.parse(sessionStorage.getItem('vehicleDetail'))
      this.option.img = this.vehicle.vehiclePhotoUrl
      if (!StringUtil.isEmpty(this.vehicle.blockStart)) {
        this.startDate = this.vehicle.blockStart.substr(0, 8)
        this.endDate = this.vehicle.blockEnd.substr(0, 8)
        this.startHour = this.vehicle.blockStart.substr(8, 2)
        this.startMinute = this.vehicle.blockStart.substr(10, 2)
        this.endHour = this.vehicle.blockEnd.substr(8, 2)
        this.endMinute = this.vehicle.blockEnd.substr(10, 2)
      }
      // 交通事業者初期値受け取り
      this.transportSelect = this.vehicle.transportId
      this.transportKind = this.vehicle.transportKind
    }
    // 判断当前类型是否为info类型，为info类型读取mst定员数
    if (this.type === 'info') {
      this.$axios.get('vehicle/queryMstPassengerNumber')
        .then(response => {
          this.mstPassengerNumber = parseInt(response.data.mstPassengerNumber)
        })
        .catch(error => {
          console.log(error)
        })
    }
    // 編集時、車両が運行便に使用されているかチェック
    if(this.func === 'editor'){
      this.$axios.get('vehicle/isUsedVehicle', {params: {vehicleId: this.vehicle.vehicleId}}).then(response => {
        if(response.data.result === 1){
          this.usedVehicle = true
        }else{
          this.usedVehicle = false
        }
      })
    }
    // 交通事業者一覧取得
    this.getTransportInfoList()
  },
  data () {
    return {
      // 车辆
      vehicle: {
        vehicleName: '',
        vehicleId: '',
        displayVehicleId: '',
        vehicleType: '',
        vehiclePlate: '',
        passengerNumber: '3',
        joinDate: loginDate,
        note: null,
        vehiclePhotoUrl: '',
        blockStart: '',
        blockEnd: '',
        blockNote: null,
        transportKind: '',
        transportId: null,
        transportName: ''
      },
      // 图片路径
      imagePath: 'Desktop/Myfolder/image001.jpg',
      option: {
        img: null,
        file: null
      },
      // blockStart日期
      startDate: '19700101',
      // blockStart日期
      startHour: '00',
      // blockStart日期
      startMinute: '00',
      // blockStart日期
      endDate: '19700101',
      // blockStart日期
      endHour: '00',
      // blockStart日期
      endMinute: '00',
      // mst定员数
      mstPassengerNumber: 3,
      // 图片入力错误
      showDialog: false,
      dialogOption: {
        showNo: true,
        text: '',
        cancelButtonText: '',
        confirmButtonText: ''
      },
      isFirstIn: true,
      transportKind: 0,
      // 交通事業者選択
      transportSelect: '',
      // 交通事業者一覧
      transportInfoList: [],
      // 車両使用フラグ
      usedVehicle: false
    }
  },
  props: {
    // 页面标题
    title: {type: String, default: ''},
    // 登录按钮名
    btnName: {type: String, default: ''},
    // 页面类型
    type: {type: String, default: 'info'},
    // 页面功能
    func: {type: String, default: 'login'}
  },
  computed: {
    startY: function () {
      if (this.vehicle.blockStart) {
        return parseInt(this.vehicle.blockStart.substr(0, 4))
      }
      return undefined
    },
    startM: function () {
      if (this.vehicle.blockStart) {
        return parseInt(this.vehicle.blockStart.substr(4, 2))
      }
      return undefined
    },
    startD: function () {
      if (this.vehicle.blockStart) {
        return parseInt(this.vehicle.blockStart.substr(6, 2))
      }
      return undefined
    },
    endY: function () {
      if (this.vehicle.blockEnd) {
        return parseInt(this.vehicle.blockEnd.substr(0, 4))
      }
      return undefined
    },
    endM: function () {
      if (this.vehicle.blockEnd) {
        return parseInt(this.vehicle.blockEnd.substr(4, 2))
      }
      return undefined
    },
    endD: function () {
      if (this.vehicle.blockEnd) {
        return parseInt(this.vehicle.blockEnd.substr(6, 2))
      }
      return undefined
    },
    // 初始化小时
    hours: function () {
      let hs = []
      for (let i = 0; i <= 23; i++) {
        if (i < 10) {
          hs.push('0' + i)
        } else {
          hs.push('' + i)
        }
      }
      return hs
    },
    // 初始化分钟
    minutes: function () {
      let ms = []
      for (let i = 0; i <= 59; i++) {
        if (i < 10) {
          ms.push('0' + i)
        } else {
          ms.push(i)
        }
      }
      return ms
    }
  },
  watch: {
    // startHour: function () {
    //   this.checkBlockTime()
    // },
    // startMinute: function () {
    //   this.checkBlockTime()
    // },
    endHour: function () {
      // this.checkBlockTime()
    },
    endMinute: function () {
      // this.checkBlockTime()
    },
    transportKind (newvalue) {
      this.transportKind = newvalue
      this.vehicle.transportKind = this.transportKind
      if(newvalue == 0){
        this.transportSelect = null
        this.vehicle.transportId = null
        this.vehicle.transportName = null
      }
    },
    // 交通事業者選択
    transportSelect(newvalue){
      this.vehicle.transportId = newvalue
      if(this.vehicle.transportKind == 1){
        this.setTransportName()
      }
    }
  },
  methods: {
    // 判断开始时间和终了时间是否有误
    checkBlockTime () {
      let startTime = DateUtil.str2Date(this.startDate + this.startHour + this.startMinute + '00')
      let endTime = DateUtil.str2Date(this.endDate + this.endHour + this.endMinute + '00')
      if (startTime.getTime() - endTime.getTime() >= 0) {
        this.showMessage('終了日は開始日以降の日付を選択してください。')
        return false
      }
      return true
    },
    // message dialog
    showMessage (text, yesNoFlag, yesText, noText) {
      this.dialogOption.text = text
      this.dialogOption.showNo = yesNoFlag
      this.dialogOption.confirmButtonText = yesText
      this.dialogOption.cancelButtonText = noText
      this.showDialog = true
      this.$refs.dialog
        .confirm()
        .then(() => {
          this.showDialog = false
        })
        .catch(() => {
          this.showDialog = false
        })
    },
    // 检测图片是否合规
    checkImage (e) {
      var file = e.target.files[0]
      return new Promise((resolve, reject) => {
        let uploadPictureMaxSize = parseInt(sessionStorage.getItem('uploadPictureMaxSize'))
        // XMサイズ以下の画像を選択して下さい。
        if (file.size > uploadPictureMaxSize * 1024 * 1024) {
          this.showMessage(uploadPictureMaxSize + 'MBサイズ以下の画像を選択して下さい。')
          this.$refs.ctlImg.value = ''
          return reject
        }
        // JPEG或はJPG形式の画像だけが選択できます。
        if (!/\.(jpg|jpeg|JPEG|JPG|png|PNG|bmp|BMP)$/.test(e.target.value)) {
          this.showMessage('JPG、PNG或はBMP形式の画像だけが選択できます。')
          this.$refs.ctlImg.value = ''
          return reject
        }
        var reader = new FileReader()
        reader.onload = e => {
          let data
          if (typeof e.target.result === 'object') {
            // 把Array Buffer转化为blob 如果是base64不需要
            data = window.URL.createObjectURL(new Blob([e.target.result]))
          } else {
            data = e.target.result
          }
          let img = new Image()
          img.src = data
          img.onload = () => {
            // var width = img.width
            // var height = img.height

            // ピクセル256×320以上の画像を選択して下さい。
            // if (width < 256 || height < 320) {
            //   this.showMessage('ピクセル256×320以上の画像を選択して下さい。')
            //   return reject
            // }
            let urllength = this.$refs.ctlImg.value.length
            let fileurl = this.$refs.ctlImg.value.substring(3, urllength)
            this.option.file = file
            this.$refs.ctlImg.value = ''
            return resolve({ data: data, fileurl: fileurl })
          }
        }
        reader.readAsArrayBuffer(file)
      })
    },
    // 加载图片
    uploadImg (e) {
      this.checkImage(e)
        .then(result => {
          if (result.data && result.fileurl) {
            // 允许跳转
            this.option.img = result.data
            this.imagePath = result.fileurl
          }
        })
        .catch(err => console.error(err))
    },
    chooseImage () {
      const event = new MouseEvent('click')
      console.log(event)
      this.$refs.ctlImg.dispatchEvent(event)
    },
    // 取消返回
    cancel () {
      if (this.func === 'login') {
        this.$router.push({name: 'VehicleList'})
      } else {
        this.$router.push({name: 'VehicleDetail', query: {vehicleId: this.vehicle.vehicleId}})
      }
    },
    // 取得BlockStart日期
    getBlockStart (selectValue) {
      this.startDate = DateUtil.getYearMonthDay(selectValue)
      // if (!this.isFirstIn) {
      //   this.checkBlockTime()
      // }
    },
    // 取得BlockEnd日期
    getBlockEnd (selectValue) {
      this.endDate = DateUtil.getYearMonthDay(selectValue)
      // if (!this.isFirstIn) {
      //   this.checkBlockTime()
      // }
      this.isFirstIn = false
    },
    // 设置Block时间的格式
    setVehicleBlockTime () {
      let startHour = this.startHour
      let startMinute = this.startMinute
      let endHour = this.endHour
      let endMinute = this.endMinute

      if (startHour === '') {
        startHour = '00'
      }
      if (startMinute === '') {
        startMinute = '00'
      }
      if (endHour === '') {
        endHour = '00'
      }
      if (endMinute === '') {
        endMinute = '00'
      }

      this.vehicle.blockStart = this.startDate + startHour + startMinute + '00'
      this.vehicle.blockEnd = this.endDate + endHour + endMinute + '00'
    },
    // 转化登录日期格式
    getLoginDate () {
      // console.log(this.vehicle.joinDate)
      return DateUtil.yearMonthDay(this.vehicle.joinDate)
    },
    // 提交
    submit (e) {
      if (this.type === 'block') {
        this.setVehicleBlockTime()
        if (!this.checkBlockTime()) {
          e.stopPropagation()
        }
      }
      // 去前后空字符串
      this.vehicle = StringUtil.trim(this.vehicle)
      this.$validator.validateAll()
        .then(result => {
          if (!result) {
            e.stopPropagation()
          }
        })
    },
    // 交通事業者一覧取得
    getTransportInfoList(){	
      this.$axios	
        .get('user/getTransportInfoList', {	
          params: {}	
        })	
        .then(response => {	
          this.transportInfoList = response.data.transportInfoList
          this.setTransportName()
        })	
        .catch(error => {	
          console.log(error)	
        })	
    },
    setTransportName(){
      for(let i = 0; i < this.transportInfoList.length; i++){
        if(this.transportInfoList[i].transportId == this.vehicle.transportId){
          this.vehicle.transportName = this.transportInfoList[i].transportName
        }
      }
    }
  }
}
</script>

<template>
<div class="vehicleinfo-component">
  <div class="col-md-12 column">
    <!-- head -->
    <div class="row clearfix">
        <div class="col-md-12 column header">
          <div class="row clearfix">
            <div class="col-md-4 column">
            </div>
            <div class="col-md-4 column F3-M-27">{{title}}</div>
            <div class="col-md-4 column">
            </div>
          </div>
        </div>
    </div>
    <!-- body -->
    <div class="row clearfix body slider">
      <div class="col-md-12 column">
        <div class="row clearfix">
          <div class="col-md-2 column" style="width:12.5%;">
            <span v-if="type=='info'" class="hint F3-R-14">※必須項目</span>
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-6 column">
                <!-- 運行区分 -->
                <div class="row clearfix">
                  <div class="col-md-3 column title bgc8 F3-R-15">
                    <span v-if="type=='info'" class="star F3-R-15">※</span>運行区分
                  </div>
                  <div style="display: flex; flex-wrap: wrap;">
                    <div v-if="type=='block'" class="col-md-9 column">
                        <div v-if="transportKind==0" class="F3-R-20 bgc5 blockedDiv">区域内</div>
                        <div v-if="transportKind==1" class="F3-R-20 bgc5 blockedDiv">区域外</div>
                    </div>
                    <div v-else class="col-md-9 column radiodiv textAlignLeft shortInput">
                      <label class="radio-inline" style="margin-right: 4%">
                        <input class="radiobutton" type="radio" name="transportKindRadio" v-model="transportKind" value="0" :disabled="usedVehicle">
                        <span></span>
                        <span class="F3-R-20">区域内</span>
                      </label>
                      <label class="radio-inline">
                        <input class="radiobutton" type="radio" name="transportKindRadio" v-model="transportKind" value="1" :disabled="usedVehicle">
                        <span></span>
                        <span class="F3-R-20">区域外</span>
                      </label>
                    </div>
                    <div v-show="usedVehicle" style="margin-left:20px; text-align:left; color:red;">※この車両は運行便に使用されているため、区分を変更できません。</div>
                  </div>

                </div>
                <!-- 交通事業者名 -->
                <div class="row clearfix" v-show="transportKind == 1">
                  <div class="col-md-3 column title bgc8 F3-R-15">
                    <span v-if="type=='info'" class="star F3-R-15">※</span>交通事業者名
                  </div>
                  <div class="col-md-9 column">
                    <select class="selectstyles selectImg F3-R-20" name="selectTransport" v-model="transportSelect" :disabled="type=='block'||usedVehicle" v-validate="transportKind == 1?'required|paintWordNo':''">
                      <option v-for='item in transportInfoList' :key="item.transportId" :value="item.transportId">
                        {{item.transportName}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="clearfix" v-show="transportKind == 1">
                  <div class="col-md-3 column">
                  </div>
                  <div class="col-md-9 column textAlignLeft errorDiv">
                  <span v-if="errors.has('selectTransport')" class="errorMessage"> {{ errors.first('selectTransport') }} </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row clearfix">
              
              <div class="col-md-6 column">
                <!-- 车辆名 -->
                <div class="row clearfix">
                  <div class="col-md-3 column title bgc8 F3-R-15">
                    <span v-if="type=='info'" class="star F3-R-15">※</span>車両名
                  </div>
                  <div class="col-md-9 column">
                    <input
                      type="text"
                      class="F3-R-20"
                      :class="{'bgc5':type=='block'}"
                      :readonly="type=='block'"
                      v-model="vehicle.vehicleName"
                      name="vehicleName"
                      v-validate="'required|paintWordNo'"
                      maxlength="50"
                      />
                  </div>
                </div>
                <div class="clearfix">
                  <div class="col-md-3 column">
                  </div>
                  <div class="col-md-9 column textAlignLeft errorDiv">
                  <span v-if="errors.has('vehicleName')" class="errorMessage"> {{ errors.first('vehicleName') }} </span>
                  </div>
                </div>
                <!-- 车辆ID -->
                <div v-if="type=='block'||func=='editor'" class="row clearfix">
                  <div class="col-md-3 column title bgc8  F3-R-15">
                   車両ID
                  </div>
                  <div class="col-md-9 column">
                    <input type="text" class="F3-R-20 bgc5" readonly v-model="vehicle.displayVehicleId"/>
                  </div>
                </div>
                <!-- 车种 -->
                <div class="row clearfix">
                  <div class="col-md-3 column title bgc8 F3-R-15">
                    <span v-if="type=='info'" class="star F3-R-15">※</span>車種
                  </div>
                  <div class="col-md-9 column">
                    <input
                      type="text"
                      class="F3-R-20"
                      :class="{'bgc5':type=='block'}"
                      :readonly="type=='block'"
                      v-model="vehicle.vehicleType"
                      name="vehicleType"
                      v-validate="'required|paintWordNo'"
                      maxlength="20"
                      />
                  </div>
                </div>
                <div class="clearfix">
                  <div class="col-md-3 column">
                  </div>
                  <div class="col-md-9 column textAlignLeft errorDiv">
                  <span v-if="errors.has('vehicleType')" class="errorMessage"> {{ errors.first('vehicleType') }} </span>
                  </div>
                </div>
                <!-- 车牌 -->
                <div class="row clearfix">
                  <div class="col-md-3 column title bgc8 F3-R-15">
                    <span v-if="type=='info'" class="star F3-R-15">※</span>車両ナンバー
                  </div>
                  <div class="col-md-9 column">
                    <input type="text"
                    class="F3-R-20"
                    :class="{'bgc5':type=='block'}"
                    :readonly="type=='block'"
                    v-model="vehicle.vehiclePlate"
                    name="vehiclePlate"
                    v-validate="'required|paintWordNo'"
                    maxlength="20"
                    />
                  </div>
                </div>
                <div class="clearfix">
                  <div class="col-md-3 column">
                  </div>
                  <div class="col-md-9 column textAlignLeft errorDiv">
                  <span v-if="errors.has('vehiclePlate')" class="errorMessage"> {{ errors.first('vehiclePlate') }} </span>
                  </div>
                </div>
                <!-- 定员数 -->
                <div class="row clearfix">
                  <div class="col-md-3 column title bgc8 F3-R-15">
                    乗車定員
                  </div>
                  <div class="col-md-9 column">
                    <input
                    type="text"
                    class="F3-R-20 bgc5"
                    v-if="type=='block'"
                    readonly
                    :value="vehicle.passengerNumber+'名'"/>
                    <select class="selectImg F3-R-20"
                      v-if="type=='info'"
                      v-model="vehicle.passengerNumber"
                      name="vehiclePassenger"
                      v-validate="'required'"
                      >
                      <option v-for="n in mstPassengerNumber" :key="n" :value="n">{{n}}名</option>
                    </select>
                  </div>
                </div>
                <div class="clearfix">
                  <div class="col-md-3 column">
                  </div>
                  <div class="col-md-9 column textAlignLeft errorDiv">
                  <span v-if="errors.has('vehiclePassenger')" class="errorMessage"> {{ errors.first('vehiclePassenger') }} </span>
                  </div>
                </div>
                <!-- 登陆日 -->
                <div v-if="type=='info'" class="row clearfix">
                  <div class="col-md-3 column title bgc8 F3-R-15">
                    登録日
                  </div>
                  <div class="col-md-9 column">
                    <input type="text" class="F3-R-20 bgc5" :value="getLoginDate()" readonly/>
                  </div>
                </div>

              </div>
              <!-- 选择图片 -->
              <div class="col-md-6 column">
                <div class="row clearfix">
                  <div class="col-md-7 column">
                    <div>
                      <div class="row clearfix">
                        <div class="bgc10">
                          <img v-show="option.img" :src="option.img" class="img-style"/>
                          <div v-show="!option.img" class="noimg-style bgc10 F2-M-18">No Image</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 column">
                    <div v-if="type=='info'" class="row clearfix">
                      <div class="col-md-12 column">
                          <input
                            ref="ctlImg"
                            class="fileInput"
                            type="file"
                            accept="image/png, image/jpeg, image/bmp, image/jpg"
                            @change="uploadImg($event)"/>
                            <button
                              id="imgSelect"
                              style="float:left;margin-top:30%;"
                              type="button"
                              class="btn  T7-radius F2-R-19"
                              @click="chooseImage">車両写真を選択</button>
                            <!-- <div class="img-path">{{imagePath}}</div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <!-- block入力项 -->
            <!-- 开始日 -->
            <div class="row clearfix" v-if="type=='block'">
              <div class="col-md-6 column">
                <div class="row clearfix">
                  <div class="col-md-3 column title bgc8 F3-R-15">
                    関始日
                  </div>
                  <div class="col-md-9 column">
                    <calendar-input
                    @getValue="getBlockStart"
                    :need-weeks=true
                    :selectY="startY"
                    :selectM="startM"
                    :selectD="startD"
                    ></calendar-input>
                  </div>
                </div>
              </div>
              <div class="col-md-6 column">
                <div class="row clearfix">
                  <div class="col-md-2 column time-select-div">
                    <select class="selectImg F3-R-20" v-model="startHour">
                      <option v-for="h in hours" :key="h" :value="h">{{h}}</option>
                    </select>
                  </div>
                  <div class="col-md-1 column time-title F3-R-17">時</div>
                  <div class="col-md-2 column time-select-div">
                    <select class="selectImg F3-R-20" v-model="startMinute">
                      <option v-for="m in minutes" :key="m" :value="m">{{m}}</option>
                    </select>
                  </div>
                  <div class="col-md-1 column time-title F3-R-17">分</div>
                </div>
              </div>
            </div>
            <!-- 终了日 -->
            <div class="row clearfix" v-if="type=='block'">
              <div class="col-md-6 column">
                <div class="row clearfix">
                  <div class="col-md-3 column title bgc8 F3-R-15">
                     終了日
                  </div>
                  <div class="col-md-9 column">
                    <calendar-input
                    @getValue="getBlockEnd"
                    :need-weeks=true
                    :selectY="endY"
                    :selectM="endM"
                    :selectD="endD"
                    ></calendar-input>
                  </div>
                </div>
              </div>
              <div class="col-md-6 column">
                <div class="row clearfix">
                  <div class="col-md-2 column time-select-div">
                    <select class="selectImg F3-R-20" v-model="endHour">
                      <option v-for="h in hours" :key="h" :value="h">{{h}}</option>
                    </select>
                  </div>
                  <div class="col-md-1 column time-title F3-R-17">時</div>
                  <div class="col-md-2 column time-select-div">
                    <select class="selectImg F3-R-20" v-model="endMinute">
                      <option v-for="m in minutes" :key="m" :value="m">{{m}}</option>
                    </select>
                  </div>
                  <div class="col-md-1 column time-title F3-R-17">分</div>
                </div>
              </div>
            </div>
            <!-- 备考 -->
            <div class="row clearfix">
              <div class="col-md-3 column note-title title bgc8 F3-R-15">
                備考
              </div>
              <div v-if="type==='info'" class="col-md-9 column note-div">
                <textarea
                v-model="vehicle.note"
                class="note F3-R-20"
                maxlength="256"
                name="vehicleNote"
                v-validate="'paintWordNo'"></textarea>
              </div>
              <div v-if="type==='block'" class="col-md-9 column note-div">
                <textarea
                v-model="vehicle.blockNote"
                class="note F3-R-20"
                maxlength="256"
                name="vehicleNote"
                v-validate="'paintWordNo'"></textarea>
              </div>
            </div>
            <div class="clearfix">
                  <div class="col-md-3 column" style="width:12.5%">
                  </div>
                  <div class="col-md-9 column textAlignLeft errorDiv" style="width:87.5%">
                  <span v-if="errors.has('vehicleNote')" class="errorMessage"> {{ errors.first('vehicleNote') }} </span>
                  </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-show="showDialog" :dialog-option="dialogOption" ref="dialog"></v-dialog>
    <!-- footer -->
    <div class="row clearfix footer">
          <div class="col-md-6 column">
            <a href="#modal-container-vehicle-info" data-toggle="modal" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
              <button class="vehicle-button" style="float:right" @click="submit" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">{{btnName}}</button>
            </a>
          </div>
          <div class="col-md-6 column">
              <button class="vehicle-button" style="float:left" @click="cancel">キャンセル</button>
          </div>
    </div>
  </div>
  <vehicle-info-window-mask
  :vehicle="vehicle"
  :option="option"
  :title="title"
  :type="type"
  :func="func"
  ></vehicle-info-window-mask>
</div>
</template>

<style scoped>
  .vehicleinfo-component{
    flex:0 0 84vh;
  }
  .header{
    padding-top: 18px;
    padding-bottom: 18px;
  }
  .hint{
    font-size: 14px;
  }
  .star{
    float: left;
  }
  .img-bg{
    background:grey;
    width:100%;
  }
  .img-style{
    height:245px;
    width:100%;
  }
  .noimg-style{
    height: 245px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .img-path{
    line-height: 50px;
    float: left;
    margin-left: 20px;
  }
  .note{
    width:100%;
    height:150px;
    resize: none;
  }
  .note-div{
    padding-right: 0px;
    width: 87.5%;
  }
  .name-strong{
    font-size: 30px;
  }
  .body{
    margin-left:4%;
    margin-right: 4%;
    font-size: 15px;
    height: 80vh;
  }
  .title{
    background: rgb(219, 219, 219);
    margin-bottom: 5px;
    line-height: 45px;
    text-align: center;
    padding-left: 5px;
    padding-right: 5px;
  }
  .note-title{
    width:12.5%;
    height: 150px;
    line-height: 130px;
  }
  .time-select-div{
    padding: 0px;
  }
  .time-title{
    padding-top: 10px;
    padding-bottom: 10px;
    margin-bottom: 5px;
  }
  input{
    width: 100%;
    height: 45px;
    padding-left: 10px;
  }
  select{
    width: 100%;
    height: 45px;
    padding-left: 10px;
    padding-left: 7px;
    border-radius: 5px;
  }
  textarea{
    padding-left: 10px;
  }
  [readonly]{
    background:rgb(240,240,240);
    border:0px;
  }
  .fileInput {
  position: absolute;
  clip: rect(0 0 0 0);
  }
  .T7-radius {
  width: 100%;
  max-width: 200px;
  height: 42px;
  background: linear-gradient(rgb(167, 167, 165) 50%, rgb(145,146,141) 50%);
  border-radius: 30px;
  color: #ffffff;
  text-align: center;
  font-size: 18px;
  padding: 0;
  border: solid 1px;
}
.vehicle-button{
  width: 65%;
  height: 55px;
  border-radius: 10px;
  /* margin: 30px; */
  font-size: 22px;
  color: #fff;
  border: 0px;
  background:linear-gradient(rgb(112, 182, 202) 50%, rgb(72,163,190) 50%);
}
.footer{
  margin-top: 40px;
  position: fixed;
  bottom: 40px;
  width: 100%;
  padding-right: 300px;
}
.selectImg {
  outline:none;
  float: right;
  text-indent: 1px;
  -moz-appearance:none;
  -webkit-appearance:none;
  background: url("../assets/dropselect.png") no-repeat scroll right center transparent;
}
.errorMessage {
  color: red;
}
.textAlignLeft {
  text-align: left;
}
.errorDiv{
  margin-top: -5px;
  margin-bottom: 5px;
}
.radiodiv {
  border-radius: 10px;
  width: 250px;
  height: 45px;
  margin-top: 5px;
  text-align: center;
  font-size: 18px;
}
.radiobutton {
  height: 30px;
  width: 30px;
}
input[type="radio"] + span {
  display: inline-block;
  width: 10px;
  vertical-align: middle;
  margin-top: 40px;
}
.blockedDiv {
  width: 100%;
  height: 45px;
  text-align: left;
  line-height: 45px;
  padding-left: 10px;
}
 @media screen and (max-device-width: 1480px) {
   .body{
     font-size: 11px;
   }
   .T7-radius{
     font-size: 14px;
   }
 }
</style>



// WEBPACK FOOTER //
// src/components/VehicleInfoComponent.vue